// Extended Mock Data for EduNexa 360 Phase 1 Teacher, Staff, Exam, Timetable, Homework, CRM, and Role Dashboards

export const teachersData = [
  {
    id: "TCH-001",
    employeeId: "EMP-TCH-101",
    name: "Dr. Alok Verma",
    gender: "Male",
    dob: "1982-04-12",
    phone: "+91 98123 45678",
    email: "alok.verma@apexacademy.edu.in",
    address: "A-45, Nirman Vihar",
    qualification: "Ph.D in Mathematics, M.Ed",
    experience: "14 Years",
    joiningDate: "2015-06-01",
    department: "Mathematics",
    designation: "Senior Professor",
    salary: 85000,
    classTeacherOf: "Class 10-A",
    subjectsAssigned: ["Advanced Mathematics", "Trigonometry"],
    photograph: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&auto=format&fit=crop&q=80",
    status: "Active"
  },
  {
    id: "TCH-002",
    employeeId: "EMP-TCH-102",
    name: "Mrs. Meena Sen",
    gender: "Female",
    dob: "1988-09-25",
    phone: "+91 97234 56789",
    email: "meena.sen@apexacademy.edu.in",
    address: "B-12, Green Park",
    qualification: "M.Sc Physics, B.Ed",
    experience: "9 Years",
    joiningDate: "2018-07-10",
    department: "Science",
    designation: "PGT Physics",
    salary: 72000,
    classTeacherOf: "Class 11-A",
    subjectsAssigned: ["Physics", "Lab Mechanics"],
    photograph: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80",
    status: "Active"
  },
  {
    id: "TCH-003",
    employeeId: "EMP-TCH-103",
    name: "Mr. Suresh Nair",
    gender: "Male",
    dob: "1985-11-04",
    phone: "+91 96345 67890",
    email: "suresh.nair@apexacademy.edu.in",
    address: "Flat 204, Nilgiri Towers",
    qualification: "M.A English Literature",
    experience: "11 Years",
    joiningDate: "2016-04-01",
    department: "Languages",
    designation: "Senior English Teacher",
    salary: 68000,
    classTeacherOf: "Class 9-B",
    subjectsAssigned: ["English Grammar", "English Literature"],
    photograph: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&auto=format&fit=crop&q=80",
    status: "Active"
  }
];

export const staffData = [
  {
    id: "STF-001",
    employeeId: "EMP-STF-201",
    name: "Mr. Rakesh Kumar",
    phone: "+91 99111 22333",
    email: "rakesh.admin@apexacademy.edu.in",
    gender: "Male",
    department: "Administration",
    designation: "Senior Registrar",
    joiningDate: "2017-03-15",
    salary: 45000,
    address: "C-90, Mayur Vihar",
    photograph: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80",
    status: "Active"
  },
  {
    id: "STF-002",
    employeeId: "EMP-STF-202",
    name: "Mrs. Sunita Devi",
    phone: "+91 98222 33444",
    email: "sunita.accounts@apexacademy.edu.in",
    gender: "Female",
    department: "Finance & Accounts",
    designation: "Assistant Accountant",
    joiningDate: "2019-08-01",
    salary: 40000,
    address: "D-42, Lajpat Nagar",
    photograph: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&auto=format&fit=crop&q=80",
    status: "Active"
  }
];

export const examsData = [
  {
    id: "EXM-01",
    examName: "Periodic Test 1 (2026-27)",
    academicSession: "2026-2027",
    class: "Class 10",
    startDate: "2026-08-01",
    endDate: "2026-08-08",
    status: "Scheduled"
  },
  {
    id: "EXM-02",
    examName: "Half Yearly Examination",
    academicSession: "2026-2027",
    class: "Class 10 & 11",
    startDate: "2026-09-15",
    endDate: "2026-09-28",
    status: "Upcoming"
  }
];

export const subjectsData = [
  { id: "SUB-1", name: "Mathematics", code: "MTH101", class: "Class 10", maxMarks: 100, passingMarks: 33 },
  { id: "SUB-2", name: "Science (Physics/Chem/Bio)", code: "SCI102", class: "Class 10", maxMarks: 100, passingMarks: 33 },
  { id: "SUB-3", name: "English Communicative", code: "ENG103", class: "Class 10", maxMarks: 100, passingMarks: 33 },
  { id: "SUB-4", name: "Social Science", code: "SST104", class: "Class 10", maxMarks: 100, passingMarks: 33 }
];

export const timetableData = [
  { day: "Monday", period: "1st Period (08:00 - 08:45)", subject: "Mathematics", teacher: "Dr. Alok Verma", room: "Room 402" },
  { day: "Monday", period: "2nd Period (08:45 - 09:30)", subject: "Science", teacher: "Mrs. Meena Sen", room: "Physics Lab" },
  { day: "Monday", period: "3rd Period (09:45 - 10:30)", subject: "English", teacher: "Mr. Suresh Nair", room: "Room 402" },
  { day: "Tuesday", period: "1st Period (08:00 - 08:45)", subject: "Social Science", teacher: "Mr. Rakesh Kumar", room: "Room 402" },
  { day: "Tuesday", period: "2nd Period (08:45 - 09:30)", subject: "Mathematics", teacher: "Dr. Alok Verma", room: "Room 402" }
];

export const homeworkData = [
  { id: "HW-01", class: "Class 10-A", subject: "Mathematics", title: "Quadratic Equations Problem Set #4", description: "Solve all problems from exercise 4.2 in the textbook. Submit notebook on Monday.", assignedDate: "2026-07-14", dueDate: "2026-07-18" },
  { id: "HW-02", class: "Class 10-A", subject: "Science", title: "Refraction of Light Diagram Practice", description: "Draw neat ray diagrams for convex lens image formation for all 6 object positions.", assignedDate: "2026-07-15", dueDate: "2026-07-19" }
];

export const admissionEnquiriesData = [
  { id: "ENQ-01", studentName: "Aryan Malhotra", parentName: "Sanjay Malhotra", phone: "+91 98112 33445", email: "sanjay.m@gmail.com", requestedClass: "Class 11 (Science)", source: "Website", inquiryDate: "2026-07-12", followupDate: "2026-07-16", status: "Interested", notes: "Keen on PCM stream and computer science." },
  { id: "ENQ-02", studentName: "Riya Sen", parentName: "Amit Sen", phone: "+91 97223 44556", email: "amitsen@yahoo.com", requestedClass: "Class 9", source: "Walk-in", inquiryDate: "2026-07-14", followupDate: "2026-07-18", status: "New", notes: "Transfer from Mumbai school." }
];

export const libraryBooksData = [
  { id: "BK-01", title: "NCERT Mathematics Class 10", author: "NCERT", isbn: "978-81-7450-633-9", category: "Academics", quantity: 45, available: 38, shelf: "Shelf A-1" },
  { id: "BK-02", title: "Concepts of Physics Vol 1", author: "H.C. Verma", isbn: "978-81-7709-187-8", category: "Reference", quantity: 20, available: 12, shelf: "Shelf B-3" }
];

export const transportVehiclesData = [
  { id: "VEH-01", vehicleNumber: "DL 1PC 9821", type: "AC Bus (42 Seater)", driver: "Ram Singh", phone: "+91 98100 11223", status: "Active" },
  { id: "VEH-02", vehicleNumber: "DL 1PC 4410", type: "Non-AC Bus (32 Seater)", driver: "Shyam Lal", phone: "+91 98200 33445", status: "Active" }
];
